// 针对详情页面中表单和下载附件是否禁用
export default {
  data() {
    return {
      isShowDownBtn: false,
      isDisableOverdueInterest: false,
      disabledFieldList: [],
      isDisabledForm: false,
    };
  },
  methods: {
    // 根据状态来判断表单是否禁用
    _formItemIsDisabledByContractStatus() {
      // TODO 这块需求未全面确定，先一个状态一个状态判断
      const currentContractStatus = this.contractStatus;
      // 根据状态判断表单禁用
      if (currentContractStatus == 'ZT02') {
        // 审批中
        this.isShowDownBtn = true;
        this.isDisableOverdueInterest = true;
        return [];
      } else if (currentContractStatus == 'ZT03') {
        this.isShowDownBtn = true;
        return [];
      } else if (currentContractStatus == 'ZT07') {
        this.isShowDownBtn = true;
        return []; // 全部禁用
      } else if (currentContractStatus == 'ZT021') {
        // 【是否定价】-是，变动单价字段不可编辑，【是否定价】-否，变动单价字段可编辑；其余字段都不可编辑
        this.isShowDownBtn = true;
        this.isDisableOverdueInterest = true;
        return [];
      } else if (currentContractStatus == 'ZT025') {
        // 删除审批中
        this.isShowDownBtn = true;
        this.isDisableOverdueInterest = true;
        return [];
      } else if (currentContractStatus == 'ZT024') {
        // 生效审批中
        this.isShowDownBtn = true;
        this.isDisableOverdueInterest = true;
        return [];
      } else if (currentContractStatus == 'ZT022') {
        // 撤回审批中
        this.isDisableOverdueInterest = true;
        this.isShowDownBtn = true;
        return [];
      } else if (currentContractStatus == 'ZT023') {
        // 关闭审批中
        this.isShowDownBtn = true;
        this.isDisableOverdueInterest = true;
        return [];
      } else if (currentContractStatus == 'ZT061') {
        // 修订中禁用这些
        this.isDisabledGenerateSales = true;
        return [
          'isFixedPrice',
          'pricingRule',
          'overShippedPercentage',
          'shortShippedPercentage',
          'performanceBondPayMethodCode',
          'performanceBond',
          'warrantyClause',
          'recyclingCompanyName',
          'platformCompanyName',
          'isGenerateSales',
          'mark',
        ];
      } else if (currentContractStatus == 'ZT051') {
        // 修改已驳回
        return [
          'isFixedPrice',
          'pricingRule',
          'overShippedPercentage',
          'shortShippedPercentage',
          'performanceBondPayMethodCode',
          'performanceBond',
          'warrantyClause',
          'recyclingCompanyName',
          'platformCompanyName',
          'mark',
        ];
      } else {
        return;
      }
    },
  },
};
